export default __webpack_public_path__ + "static/media/2.4bec5e66.png";